import http from './http'

export default {
  companies: (params) => http.get('/platform/v1/companies', { params }),
  setActingCompany: (companyId) =>
    http.put('/platform/v1/acting-company', { company_id: companyId == null ? null : companyId }),
  e2eGallery: (params) => http.get('/platform/v1/e2e-gallery', { params }),
  e2eGalleryReleases: () => http.get('/platform/v1/e2e-gallery/releases'),
  usage: {
    ingest: (body) => http.post('/platform/v1/usage/events', body),
    summary: (params) => http.get('/platform/v1/usage/summary', { params }),
    events: (params) => http.get('/platform/v1/usage/events', { params }),
    sessions: (params) => http.get('/platform/v1/usage/sessions', { params }),
  },
}
